import { render } from "./AdminSysAnnouncementsTab.vue?vue&type=template&id=12431c70&ts=true"
import script from "./AdminSysAnnouncementsTab.vue?vue&type=script&lang=ts"
export * from "./AdminSysAnnouncementsTab.vue?vue&type=script&lang=ts"

import "./AdminSysAnnouncementsTab.vue?vue&type=style&index=0&id=12431c70&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__